<template>
  <div>
    <!-- Form for editing the student -->
    <form @submit.prevent="submitForm">

      <input type="text" id="status" v-model="localStudent.student_status" class="form-control" required disabled>
      <input type="text" id="id" v-model="localStudent.id" class="form-control" required disabled>

      <!-- First Name Input -->
      <div class="mb-3">
        <label for="first_name" class="form-label">First Name</label>
        <input type="text" id="first_name" v-model="localStudent.first_name" class="form-control" required>
      </div>

      <!-- Last Name Input -->
      <div class="mb-3">
        <label for="last_name" class="form-label">Last Name</label>
        <input type="text" id="last_name" v-model="localStudent.last_name" class="form-control" required>
      </div>

      <!-- Contact Input -->
      <div class="mb-3">
        <label for="contact" class="form-label">Contact</label>
        <input type="text" id="contact" v-model="localStudent.contact" class="form-control" required>
      </div>

      <!-- Grade Select Dropdown -->
      <div class="mb-3">
        <label for="grade" class="form-label">Grade</label>
        <select id="grade" v-model="localStudent.grade_id" class="form-select" required>
          <option v-for="grade in grades" :key="grade.id" :value="grade.id">
            {{ grade.grade_level }}
          </option>
        </select>
      </div>

      <!-- Institute Select Dropdown -->
      <div class="mb-3">
        <label for="institute" class="form-label">Institute Name</label>
        <select id="institute" v-model="localStudent.institute_id" class="form-select" required>
          <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
            {{ institute.institute_name }}
          </option>
        </select>
      </div>

      <!-- Age Input -->
      <div class="mb-3">
        <label for="age" class="form-label">Age</label>
        <input type="text" id="age" v-model="localStudent.age" class="form-control" required>
      </div>

      <!-- Birth Day Input -->
      <div class="mb-3">
        <label for="birth_day" class="form-label">Birth Day</label>
        <input type="text" id="birth_day" v-model="localStudent.birth_day" class="form-control" required>
      </div>

      <!-- Gender Field -->
      <div class="form-group">
        <label for="gender" class="text-start d-block">
          <i class="bi bi-gender-ambiguous"></i> Gender
        </label>
        <select v-model="localStudent.gender" id="gender" class="form-control" required>
          <option value="" disabled>Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
      </div>

      <button type="submit" class="btn btn-primary">Save Changes</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    student: {
      type: Object,
      default: () => ({
        id: '',
        first_name: '',
        last_name: '',
        contact: '',
        grade_id: null,
        institute_id: null,
        age: '',
        birth_day: '',
        gender: ''
      })
    }
  },
  data() {
    return {
      localStudent: this.student ? { ...this.student } : {
        id: '',
        first_name: '',
        last_name: '',
        contact: '',
        grade_id: null,
        institute_id: null,
        age: '',
        birth_day: '',
        gender: ''
      },
      grades: [],
      institutes: [],
      errorMessage: ''
    };
  },
  watch: {
    student(newStudent) {
      if (newStudent) {
        this.localStudent = { ...newStudent };
      }
    }
  },
  mounted() {
    this.fetchGrades();
    this.fetchInstitutes();
  },
  methods: {
    async fetchGrades() {
      try {
        const response = await axios.get('/get-all-grades');
        this.grades = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching grades.';
      }
    },
    async fetchInstitutes() {
      try {
        const response = await axios.get('/get-all-institutes');
        this.institutes = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching institutes.';
      }
    },
    async submitForm() {
      try {
        const formData = new FormData();
        formData.append('id', this.localStudent.id);
        formData.append('first_name', this.localStudent.first_name);
        formData.append('last_name', this.localStudent.last_name);
        formData.append('contact', this.localStudent.contact);
        formData.append('grade', this.localStudent.grade_id);
        formData.append('institute', this.localStudent.institute_id);
        formData.append('age', this.localStudent.age);
        formData.append('birth_day', this.localStudent.birth_day);
        formData.append('gender', this.localStudent.gender);

        // Submit the updated data
        await axios.post('/update-student', formData);

        this.$emit('update-student', this.localStudent);
        alert('Student updated successfully');
      } catch (error) {
        console.error('Error updating student:', error);
        alert('Failed to update student');
      }
    }
  }
};
</script>

<style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
